import type { JWTPayload } from "../auth/auth.types";

export type Visibility = "PUBLIC" | "PRIVATE";

export type PodcastCreationJobStatus =
	| "PENDING"
	| "PROCESSING"
	| "COMPLETED"
	| "FAILED";
export type PodcastChapterCreationJobStatus =
	| "CREATED"
	| "SENT"
	| "PENDING"
	| "SUCCESS"
	| "FAILED";

/**
 * Podcast length type
 * Must match backend Prisma enum
 */
export type PodcastLength = "SHORT" | "MEDIUM" | "LONG";

/**
 * Podcast length constants
 * Single source of truth for podcast lengths in frontend
 */
export const PODCAST_LENGTH = {
	SHORT: "SHORT" as const,
	MEDIUM: "MEDIUM" as const,
	LONG: "LONG" as const,
} satisfies Record<string, PodcastLength>;

/**
 * Default podcast length
 */
export const DEFAULT_PODCAST_LENGTH = PODCAST_LENGTH.MEDIUM;

export interface PodcastChapterCreationJob {
	id: string;
	createdAt: string;
	updatedAt: string;
	podcastChapterId: string;
	status: PodcastChapterCreationJobStatus;
}

export interface PodcastChapter {
	id: string;
	title: string;
	s3Path: string | null;
	script: string;
	extractedText: string;
	language: string;
	index: number;
	length: number; // length of the chapter audio in milliseconds
	podcastId: string;
	included: boolean;
	creationJob?: PodcastChapterCreationJob;
}

export interface StorageFile {
	id: string;
	blobLink: string;
	createdAt: string;
	updatedAt: string;
}

export interface PodWorkspace {
	id: string;
	title: string;
	visibility: Visibility;
	createdAt: string;
	createdById: string;
}

export interface Podcast {
	id: string;
	title: string;
	createdById: string;
	createdBy?: JWTPayload;
	joinedPodcastFileId: string;
	joinedPodcastFile?: StorageFile;
	visibility: Visibility;
	transcription: string;
	language: string;
	chapters: PodcastChapter[];
	length: number;
	podWorkspaceId: string;
	podWorkspace?: PodWorkspace;
	status: PodcastCreationJobStatus;
	podcastLength: PodcastLength;
	coinCost: number;
	estimatedCost: number;
	costApproved: boolean;
	costApprovedAt: string | null;
}

export interface Chapter {
	startTime: number;
	endTime: number;
	text: string;
}
